import { render, staticRenderFns } from "./CollegeRank.vue?vue&type=template&id=46e89d0c&"
import script from "./CollegeRank.vue?vue&type=script&lang=js&"
export * from "./CollegeRank.vue?vue&type=script&lang=js&"
import style0 from "./CollegeRank.vue?vue&type=style&index=0&id=46e89d0c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports